export default __webpack_public_path__ + "static/media/legs.3e5b0311.jpg";